module.exports = __webpack_public_path__ + "static/media/arrow.eb02001c.svg";